const strings = {
  'pt-br': {
    'RECENT DESCRIPTIONS': 'DESCRIÇÕES RECENTES',
    WISHLIST: 'LISTA DE DESEJOS',
    HOME: 'INÍCIO',
    Close: 'Fechar',
    Search: 'Busca',
    Credits: 'Créditos',
    'Contact Us': 'Contato',
    Support: 'Suporte',
    'YouDescribe is a project of': 'YouDescribe é um projeto do',
    'Load more videos': 'Carregar mais vídeos',
    'Load more': 'Carregar mais',
    'Sign in with Google': 'Entrar com o Google',
    'All rights reserved': 'Todos os direitos reservados',
    'YouDescribe - Audio Description for YouTube Videos':
      'YouDescribe - Áudio Descrição para vídeos do YouTube',
    'Search for a YouTube video. If a video with an audio description matching the search criteria exists, it will be available in the first section. If not, Youtube videos without audio descriptions matching the search criteria will be listed in the second section and requests for any of those videos can be made.':
      'Busque por um vídeo do YouTube. Se um vídeo com audio descrição for encontrado, ele estará no primeiro bloco. Caso contrário estará no segundo bloco e você poderá solicitar uma audio descrição.',
    'You must sign in to perform this action':
      'Você precisa estar logado para usar esse recurso',
    'You have to be logged in in order to vote':
      'Você precisa estar logado para votar',
    'It was impossible to vote. Maybe your session has expired. Try to logout and login again.':
      'Não foi possível votar. Tente logar novamente com seu usuário.',
    'YouDescribe - Authoring Tool': 'YouDescribe - Ferramenta de edição',
    'You have to be logged in in order to describe this video':
      'Você precisa estar logado para poder descrever este vídeo',
    'Finish using your available record tracks':
      'Termine de usar suas trilhas disponíveis',
    'You can just add more tracks when you finish recording the existing one':
      'Você só pode adicionar mais trilhas quando terminar de usar as disponíveis',
    'Are you sure you want to remove this track? This action cannot be undone!':
      'Você tem certeza que deseja apagar esta trilha? Não será possível desfazer essa ação',
    'Impossible to descrease the start time. It is already 0':
      'Não é possível diminuir o tempo de início, pois já está em 0',
    'Impossible to increase the start time more':
      'Não é possível aumentar mais o tempo de início',
    'Are you sure you want to change from EXTENDED to INLINE?':
      'Você tem certeza que quer mudar de EXTENDIDA para LINEAR?',
    'Are you sure you want to change from INLINE to EXTENDED?':
      'Você tem certeza que quer mudar de LINEAR para EXTENDIDA?',
    'You need to be logged in in order to record audio clips':
      'Você precisa estar logado para gravar trilhas',
    'You need to stop recording in order to activate any other track':
      'Você precisa parar sua gravação para ativar outra trilha',
    'Are you sure you wanna publish this audio description?':
      'Você tem certeza que quer publicar essa áudio descrição?',
    'Are you sure you wanna unpublish this audio description?':
      'Você tem certeza que quer despublicar essa áudio descrição?',
    'Are you sure you want to delete the audio description? This will remove all recorder tracks and cannot be undone':
      'Você tem certeza que quer remover essa áudio descrição? Isso removerá todas as trilhas e não poderá ser desfeito',
    'Authoring is not available on this screen size. Please use a larger screen to add a description':
      'A ferramenta de edição não está disponível para o seu tamanho de tela. Use uma resolução maior',
    Loading: 'Carregando',
    'My descriptions': 'Minhas áudio descrições',
    Unpublish: 'Despublicar',
    Publish: 'Publicar',
    Delete: 'Apagar',
    'Complete remove this audio description': 'Remove esta áudio descrição',
    'Unpublish this audio description for the current video':
      'Despublicar esta áudio descrição',
    'Publish the video along with all audio description tracks':
      'Publicar este vídeo com áudio descrição',
    'Save notes and labels anytime': 'Grava as notas e os títulos das trilhas',
    Save: 'Gravar',
    "Add an inline audio description track which plays concurrently with the video's audio":
      'Adiciona uma trilha linear que irá ser reproduzida junto com o áudio do vídeo',
    'Add an extended audio description track which pauses the video as it plays and then resumes the video when it finishes':
      'Adiciona uma trilha extendida que irá pausar o vídeo para ser reproduzida. Assim que terminar, o vídeo voltará a ser reproduzido',
    'YouDescribe - Wish List': 'YouDescribe - Lista de desejos',
    Author: 'Autor',
    'Published on': 'Publicado em',

    'Turn off descriptions for this video':
      'Desligar a áudio descrição deste vídeo',
    'Turn off descriptions': 'Desligar áudio descrição',
    'Add a new description for this video':
      'Adicionar uma nova áudio descrição para este vídeo',
    'Add description': 'Adicionar áudio descrição',
    'Turn on descriptions for this video':
      'Ligar a áudio descrição deste vídeo',
    'Turn on descriptions': 'Ligar áudio descrição',
    'Selected description': 'Áudio descrição selecionada',
    "Rate this describer's audio description":
      'Avalie a áudio descrição deste descritor',
    'Rate description': 'Avalie a áudio descrição',
    "Select this describer's audio description":
      'Selecione a áudio descrição deste descritor',
    'Use description': 'Utilize esta áudio desrição',
    'Descriptions off': 'Áudio descrições desligadas',
    'Request an audio description for this video':
      'Solicite uma áudio descrição para este vídeo',
    'Add to wishlist': 'Adicionar na lista de desejos',
    'Search results page': 'Página de resultados de busca',
    'DESCRIBED VIDEOS': 'VÍDEOS COM ÁUDIO DESCRIÇÃO',
    'NON-DESCRIBED VIDEOS': 'VÍDEOS SEM ÁUDIO DESCRIÇÃO',
    'There are no described videos that match your search':
      'Não existem vídeos com áudio descrição que satisfaçam a sua busca',
    'Create an audio description for this video':
      'Crie uma áudio descrição para este vídeo',
    Describe: 'Descrever',
    'Sign out': 'Sair',
    'View my described videos': 'Ver meus vídeos com áudio descrição',
    'MY DESCRIBED VIDEOS': 'MEUS VÍDEOS COM ÁUDIO DESCRIÇÃO',
    Edit: 'Editar',
    'Edit the audio description for this video':
      'Editar a áudio descrição deste vídeo',
    'Other description options': 'Outras opções para a áudio descrição',
    Notes: 'Anotações',
    Language: 'Idioma',
    'Audio description language': 'Idioma da áudio descrição',
    'Unlabeled saved track': 'Trilha sem nome',
    'Label for this track': 'Nome desta trilha',
    'Add inline': '+ linear',
    'Add extended': '+ extendida',
    'Use this space as your notepad while you are recording all your descriptions tracks.':
      'Utilize este espaço como um bloco de notas para fazer anotações que ajudarão na gravação das áudio descrições.',
    'Please rate this description with 1 star being unusable and 5 stars being perfect':
      'Avalie esta áudio descrição sendo que 1 estrela é igual a péssima e 5 estrelas perfeita',
    'Thanks for rating this description!': 'Obrigado pela avaliação!',
    'Thank you for your feedback!': 'Obrigado pelo retorno!',
    'Optional feedback': 'Avaliação adicional',
    'Please give additional feedback to help describers make adjustments':
      'Contribua com essa avaliação adicional para ajudar os áudio descritores a fazerem ajustes',
    'Check all that apply': 'Marque todas que fizerem sentido',
    'Needs better audio quality': 'Precisa melhorar a qualidade do áudio',
    'Needs better diction': 'Precisa melhorar a dicção',
    'Needs more inline descriptions': 'Precisa de mais trilhas lineares',
    'Needs more extended descriptions': 'Precisa de mais trilhas extendidas',
    'Do not step on the dialogue': 'Descrições em cima de diálogos do vídeo',
    'Needs less description': 'Precisa de menos descrição',
    'Needs more description': 'Precisa de mais descrição',
    'Description does not match video tone':
      'O volume da descrição não está de acordo com o volume do vídeo',
    'Description has innappropriate content':
      'A descrição tem conteúdo inapropriado',
    'Description given before action': 'Descrições antes das ações',
    'Needs to read all onscreen text':
      'Precisa ler todos os textos que aparecem na tela',
    Submit: 'Enviar',
    'Submit feedback': 'Enviar avaliação',
    'General information about YouDescribe':
      'Informações gerais sobre o YouDescribe',
    'FAQ pages for viewers': 'Perguntas frequentes para videntes',
    'FAQ for describers': 'Perguntas frequentes para áudio descritores',
    'A step-by-step audio description tutorial with a trouble shooting section':
      'Tutorial passo-a-passo para [audio descritores',
    SUPPORT: 'SUPORTE',
    'It is not possible to vote again for this video.':
      'Não é possível votar novamente neste vídeo.',

    Statistics: 'Estatisticas',
    Videos: 'Vídeos',
    Descriptions: 'Descrições',
    'Description Detail': 'Descrição Detalhe',
    'My profile': 'Meus perfil',
    Admin: 'Admin',
    'Two quick questions': 'Duas perguntas rápidas',
    'About the video you just watched.':
      'Sobre o vídeo que você acabou de assistir.',
    'How well were you able to follow what was happening in the video?':
      'Quão bem você conseguiu acompanhar o que acontecia no vídeo?',
    'How much did you enjoy the video?': 'Quanto você gostou do vídeo?',
    "Anything else you'd like us to know?":
      'Mais alguma coisa que você gostaria de nos contar?',
    optional: 'opcional',
    'Optional — any other thoughts about the video or its description.':
      'Opcional — outros comentários sobre o vídeo ou sua audiodescrição.',
    'Stop dictation': 'Parar ditado',
    'Dictate your answer': 'Dite sua resposta',
    'Listening…': 'Ouvindo…',
    Back: 'Voltar',
    'Submit & finish': 'Enviar e finalizar',
    'Not at all': 'Nem um pouco',
    'A little': 'Um pouco',
    Somewhat: 'Razoavelmente',
    Mostly: 'Na maior parte',
    Completely: 'Completamente',
    'Quite a bit': 'Bastante',
    'A great deal': 'Muitíssimo',
  },
  'en-us': {
    'RECENT DESCRIPTIONS': 'RECENT DESCRIPTIONS',
    WISHLIST: 'WISHLIST',
    HOME: 'HOME',
    Close: 'Close',
    Search: 'Search',
    Credits: 'Credits',
    'Contact Us': 'Contact Us',
    Support: 'Support',
    'YouDescribe is a project of': 'YouDescribe is a project of',
    'Load more videos': 'Load more videos',
    'Load more': 'Load more',
    'Sign in with Google': 'Sign in with Google',
    'All rights reserved': 'All rights reserved',
    'YouDescribe - Audio Description for YouTube Videos':
      'YouDescribe - Audio Description for YouTube Videos',
    'Search for a YouTube video. If a video with an audio description matching the search criteria exists, it will be available in the first section. If not, Youtube videos without audio descriptions matching the search criteria will be listed in the second section and requests for any of those videos can be made.':
      'Search for a YouTube video. If a video with an audio description matching the search criteria exists, it will be available in the first section. If not, Youtube videos without audio descriptions matching the search criteria will be listed in the second section and requests for any of those videos can be made.',
    'You must sign in to perform this action':
      'You must sign in to perform this action',
    'You have to be logged in in order to vote':
      'You have to be logged in in order to vote',
    'It was impossible to vote. Maybe your session has expired. Try to logout and login again.':
      'It was impossible to vote. Maybe your session has expired. Try to logout and login again.',
    'YouDescribe - Authoring Tool': 'YouDescribe - Authoring Tool',
    'You have to be logged in in order to describe this video':
      'You have to be logged in in order to describe this video',
    'Finish using your available record tracks':
      'Finish using your available record tracks',
    'You can just add more tracks when you finish recording the existing one':
      'You can just add more tracks when you finish recording the existing one',
    'Are you sure you want to remove this track? This action cannot be undone!':
      'Are you sure you want to remove this track? This action cannot be undone!',
    'Impossible to descrease the start time. It is already 0':
      'Impossible to descrease the start time. It is already 0',
    'Impossible to increase the start time more':
      'Impossible to increase the start time more',
    'Are you sure you want to change from EXTENDED to INLINE?':
      'Are you sure you want to change from EXTENDED to INLINE?',
    'Are you sure you want to change from INLINE to EXTENDED?':
      'Are you sure you want to change from INLINE to EXTENDED?',
    'You need to be logged in in order to record audio clips':
      'You need to be logged in in order to record audio clips',
    'You need to stop recording in order to activate any other track':
      'You need to stop recording in order to activate any other track',
    'Are you sure you wanna publish this audio description?':
      'Are you sure you wanna publish this audio description?',
    'Are you sure you wanna unpublish this audio description?':
      'Are you sure you wanna unpublish this audio description?',
    'Are you sure you want to delete the audio description? This will remove all recorder tracks and cannot be undone':
      'Are you sure you want to delete the audio description? This will remove all recorder tracks and cannot be undone',
    'Authoring is not available on this screen size. Please use a larger screen to add a description':
      'Authoring is not available on this screen size. Please use a larger screen to add a description',
    Loading: 'Loading',
    'My descriptions': 'My descriptions',
    Unpublish: 'Unpublish',
    Publish: 'Publish',
    Delete: 'Delete',
    'Complete remove this audio description':
      'Complete remove this audio description',
    'Unpublish this audio description for the current video':
      'Unpublish this audio description for the current video',
    'Publish the video along with all audio description tracks':
      'Publish the video along with all audio description tracks',
    'Save notes and labels anytime': 'Save notes and labels anytime',
    Save: 'Save',
    'Play audio description from the start':
      'Play audio description from the start',
    'Play from Start': 'Play from Start',
    "Add an inline audio description track which plays concurrently with the video's audio":
      "Add an inline audio description track which plays concurrently with the video's audio",
    'Add an extended audio description track which pauses the video as it plays and then resumes the video when it finishes':
      'Add an extended audio description track which pauses the video as it plays and then resumes the video when it finishes',
    'YouDescribe - Wish List': 'YouDescribe - Wish List',
    Author: 'Author',
    'Published on': 'Published on',
    'Turn off descriptions for this video':
      'Turn off descriptions for this video',
    'Turn off descriptions': 'Turn off descriptions',
    'Add a new description for this video':
      'Add a new description for this video',
    'Add description': 'Add description',
    'Turn on descriptions for this video':
      'Turn on descriptions for this video',
    'Turn on descriptions': 'Turn on descriptions',
    'Selected description': 'Selected description',
    "Rate this describer's audio description":
      "Rate this describer's audio description",
    'Rate description': 'Rate description',
    "Select this describer's audio description":
      "Select this describer's audio description",
    'Use description': 'Use description',
    'Descriptions off': 'Descriptions off',
    'Request an audio description for this video':
      'Request an audio description for this video',
    'Add to WISHLIST': 'Add to WISHLIST',
    'Search results page': 'Search results page',
    'DESCRIBED VIDEOS': 'DESCRIBED VIDEOS',
    'NON-DESCRIBED VIDEOS': 'NON-DESCRIBED VIDEOS',
    'There are no described videos that match your search':
      'There are no described videos that match your search',
    'Create an audio description for this video':
      'Create an audio description for this video',
    Describe: 'Describe',
    'Sign out': 'Sign out',
    'View my described videos': 'View my described videos',
    'MY DESCRIBED VIDEOS': 'MY DESCRIBED VIDEOS',
    Edit: 'Edit',
    'Edit the audio description for this video':
      'Edit the audio description for this video',
    'Other description options': 'Other description options',
    Notes: 'Notes',
    Language: 'Language',
    'Audio description language': 'Audio description language',
    'Unlabeled saved track': 'Unlabeled saved track',
    'Label for this track': 'Label for this track',
    'Add inline': 'Add inline',
    'Add extended': 'Add extended',
    'Use this space as your notepad while you are recording all your descriptions tracks.':
      'Use this space as your notepad while you are recording all your descriptions tracks.',
    'Please rate this description with 1 star being unusable and 5 stars being perfect':
      'Please rate this description with 1 star being unusable and 5 stars being perfect',
    'Thanks for rating this description!':
      'Thanks for rating this description!',
    'Thank you for your feedback!': 'Thank you for your feedback!',
    'Optional feedback': 'Optional feedback',
    'Please give additional feedback to help describers make adjustments':
      'Please give additional feedback to help describers make adjustments',
    'Check all that apply': 'Check all that apply',
    'Needs better audio quality': 'Needs better audio quality',
    'Needs better diction': 'Needs better diction',
    'Needs more inline descriptions': 'Needs more inline descriptions',
    'Needs more extended descriptions': 'Needs more extended descriptions',
    'Do not step on the dialogue': 'Do not step on the dialogue',
    'Needs less description': 'Needs less description',
    'Needs more description': 'Needs more description',
    'Needs to read all onscreen text': 'Needs to read all onscreen text',
    'Description does not match video tone':
      'Description does not match video tone',
    'Description has innappropriate content':
      'Description has innappropriate content',
    'Description given before action': 'Description given before action',
    Submit: 'Submit',
    'Submit feedback': 'Submit feedback',
    'General information about YouDescribe':
      'General information about YouDescribe',
    'FAQ pages for viewers': 'FAQ pages for viewers',
    'FAQ for describers': 'FAQ for describers',
    'A step-by-step audio description tutorial with a trouble shooting section':
      'A step-by-step audio description tutorial with a trouble shooting section',
    SUPPORT: 'SUPPORT',
    'It is not possible to vote again for this video.':
      'It is not possible to vote again for this video.',

    Statistics: 'Statistics',
    Videos: 'Videos',
    Descriptions: 'Descriptions',
    'Description Detail': 'Description Detail',
    'My profile': 'My profile',
    Admin: 'Admin',
    'Freestyle Description': 'Freestyle Description',
    'Request AI Descriptions': 'Request AI Descriptions',
    HISTORY: 'HISTORY',
    'AI REQUESTED VIDEOS': 'AI REQUESTED VIDEOS',
    'Go to descriptions': 'Go to descriptions',
    'MY WISHLIST': 'MY WISHLIST',
    'Add Freestyle Description': 'Add Freestyle Description',
    'Go To Descriptions': 'Go to Descriptions',
    'Provide feedback for this describer':
      'Provide feedback for this describer',
    'MY DESCRIPTIONS': 'MY DESCRIPTIONS',
    'Two quick questions': 'Two quick questions',
    'About the video you just watched.': 'About the video you just watched.',
    'How well were you able to follow what was happening in the video?':
      'How well were you able to follow what was happening in the video?',
    'How much did you enjoy the video?': 'How much did you enjoy the video?',
    "Anything else you'd like us to know?":
      "Anything else you'd like us to know?",
    optional: 'optional',
    'Optional — any other thoughts about the video or its description.':
      'Optional — any other thoughts about the video or its description.',
    'Stop dictation': 'Stop dictation',
    'Dictate your answer': 'Dictate your answer',
    'Listening…': 'Listening…',
    Back: 'Back',
    'Submit & finish': 'Submit & finish',
    'Not at all': 'Not at all',
    'A little': 'A little',
    Somewhat: 'Somewhat',
    Mostly: 'Mostly',
    Completely: 'Completely',
    'Quite a bit': 'Quite a bit',
    'A great deal': 'A great deal',
  },
}

export default strings
